import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles({
  formWrapper: {
    display: "flex",
    overflowX: "auto",
    padding: "20px 0"
  },
  cardsWrapper: {
    boxShadow: "rgba(0, 0, 0, 0.07) 2px 2px 10px 0px"
  },
  disabled: {
    opacity: "0.5"
  },
  disabledReasonInfo: {
    fontSize: "12px",
    textAlign: "center",
    color: "#a4a4a4"
  },
  danger: {
    color: "#DF1845"
  },
  womensDaySpclOfferTermsCondWrapper: {
    margin: "20px 0 40px"
  },
  womensDaySpclOfferTermsCond: {
    paddingLeft: "30px",
    lineHeight: "1.25rem",
    fontSize: "0.75rem",
    fontWeight: 400,
    color: "#3B3A3A"
  },
  spclPackageSupscript: {
    fontSize: "1rem",
    fontWeight: 700
  },
  women_tandC_link: {
    textDecoration: "underline",
    color: "#3B3A3A",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline"
    }
  }
});
